<template>
  <div>
    <!-- 
      New, mobile's view
    -->
    <a-modal v-if="isMobile()" v-model="isVisible" title="Edit" @ok="onSubmit">
      <a-row type="flex" justify="space-between" align="top">
        <a-col :span="24">
          <div>
            Name
            <a-input v-model="room.name" placeholder="" />
            <div style="margin: 10px 0" />
            Floor
            <a-input v-model="room.floor" placeholder="" />
            <div style="margin: 10px 0" />
            Type
            <a-input v-model="room.type" placeholder="" />
            <div style="margin: 10px 0" />
            IP Address
            <a-input v-model="room.ip" placeholder="" />
            <div style="margin: 10px 0" />
            Card
            <a-input v-model="room.rfid" placeholder="" />
            <div style="margin: 10px 0" />
            Capacity
            <a-input v-model="room.capacity" placeholder="" />
            <div style="margin: 10px 0" />
            Allow for booking
            <a-select default-value="Yes" v-model="room.allowBooking" style="width: 100%">
              <a-select-option value="Yes"> Yes </a-select-option>
              <a-select-option value="No"> No </a-select-option>
            </a-select>
            <div style="margin: 10px 0" />
            Status
            <a-select default-value="Enable" v-model="room.status" style="width: 100%">
              <a-select-option value="Enable"> Enable </a-select-option>
              <a-select-option value="Disable"> Disable </a-select-option>
            </a-select>
            <div style="margin: 10px 0" />
            Remark
            <a-textarea v-model="room.remark" placeholder="" :rows="7" />
            <div style="margin: 10px 0" />
          </div>
        </a-col>
      </a-row>
    </a-modal>

    <!-- 
      New, desktop's view
    -->
    <a-modal v-else v-model="isVisible" title="Edit" @ok="onSubmit" width="60%">
      <a-row type="flex" justify="space-between" align="top">
        <a-col :span="12">
          <div>
            Name
            <a-input v-model="room.name" placeholder="" />
            <div style="margin: 10px 0" />
            Floor
            <a-input v-model="room.floor" placeholder="" />
            <div style="margin: 10px 0" />
            Type
            <a-input v-model="room.type" placeholder="" />
            <div style="margin: 10px 0" />
            IP Address
            <a-input v-model="room.ip" placeholder="" />
            <div style="margin: 10px 0" />
            Card
            <a-input v-model="room.rfid" placeholder="" />
            <div style="margin: 10px 0" />
          </div>
        </a-col>
        <a-col :span="12">
          <div style="padding-left: 10px">
            Capacity
            <a-input v-model="room.capacity" placeholder="" />
            <div style="margin: 10px 0" />
            Allow for booking
            <a-select default-value="Yes" v-model="room.allowBooking" style="width: 100%">
              <a-select-option value="Yes"> Yes </a-select-option>
              <a-select-option value="No"> No </a-select-option>
            </a-select>
            <div style="margin: 10px 0" />
            Status
            <a-select default-value="Enable" v-model="room.status" style="width: 100%">
              <a-select-option value="Enable"> Enable </a-select-option>
              <a-select-option value="Disable"> Disable </a-select-option>
            </a-select>
            <div style="margin: 10px 0" />
            Remark
            <a-textarea v-model="room.remark" placeholder="" :rows="7" />
            <div style="margin: 10px 0" />
          </div>
        </a-col>
      </a-row>
    </a-modal>

    <!--
      Data, mobile's view
    -->
    <div v-if="isMobile()">
      <!-- 
			Body
			-->
      <a-card :bordered="false" class="header-solid h-full" style="margin-bottom: 10px">
        <a-row>
          <a-col :span="4"> Name: </a-col>
          <a-col :span="20">
            {{ room.name }}
          </a-col>
        </a-row>

        <a-row>
          <a-col :span="4"> Type: </a-col>
          <a-col :span="8">
            {{ room.type }}
          </a-col>
          <a-col :span="4"> Floor: </a-col>
          <a-col :span="8">
            {{ room.floor }}
          </a-col>
        </a-row>

        <a-row>
          <a-col :span="4"> IP: </a-col>
          <a-col :span="8">
            {{ room.ip }}
          </a-col>
          <a-col :span="4"> Cap: </a-col>
          <a-col :span="8">
            {{ room.capacity }}
          </a-col>
        </a-row>

        <a-row>
          <a-col :span="4"> Card: </a-col>
          <a-col :span="20">
            {{ room.rfid }}
          </a-col>
        </a-row>

        <a-row>
          <a-col :span="4"> Remark: </a-col>
          <a-col :span="20">
            {{ room.remark }}
          </a-col>
        </a-row>

        <a-divider />

        <a-row>
          <a-col :span="12"> Always On: </a-col>
          <a-col :span="12">
            {{ room.open === true ? "Yes" : "No" }}
          </a-col>
        </a-row>

        <a-row>
          <a-col :span="12"> Allow Booking: </a-col>
          <a-col :span="12">
            {{ room.allowBooking }}
          </a-col>
        </a-row>

        <a-row>
          <a-col :span="12"> Status: </a-col>
          <a-col :span="12">
            {{ room.status }}
          </a-col>
        </a-row>

        <a-divider />

        <div style="width: 100%">
          <div style="float: right">
            Always On &nbsp;
            <a-switch v-model="room.open" @change="onToggleOnOff" />
            <a-divider type="vertical" />
            <a-button type="default" shape="circle" icon="edit" @click="onEdit" />&nbsp;
            <a-button type="danger" shape="circle" icon="delete" @click="onDelete" />
          </div>
        </div>
      </a-card>
    </div>

    <!--
      Data, desktop's view
    -->
    <div v-else>
      <a-card :bordered="false" class="header-solid h-full mb-24">
        <!-- Title -->
        <template #title>
          <a-row type="flex" justify="space-between" align="top">
            <a-col :span="12">
              <h5 class="font-semibold m-0">Name: {{ room.name }}</h5>
            </a-col>
            <a-col :span="12" style="
                display: flex;
                align-items: center;
                justify-content: flex-end;
              ">
              Always On &nbsp;
              <a-switch v-model="room.open" @change="onToggleOnOff" />
              <a-divider type="vertical" />
              <a-button type="default" shape="circle" icon="edit" @click="onEdit" />&nbsp;
              <a-button type="danger" shape="circle" icon="delete" @click="onDelete" />
            </a-col>
          </a-row>
        </template>
        <!-- 
          body 
        -->
        <a-table :columns="columns" :data-source="data" :pagination="false" rowKey="_id">
          <template slot="open" slot-scope="open">
            <a-tag v-if="open === true" color="green">Yes</a-tag>
            <a-tag v-if="open === false" color="red">No</a-tag>
          </template>
          <template slot="allowBooking" slot-scope="allowBooking">
            <a-tag v-if="allowBooking === 'Yes'" color="green">{{
      allowBooking
    }}</a-tag>
            <a-tag v-if="allowBooking === 'No'" color="red">{{
      allowBooking
    }}</a-tag>
          </template>
          <template slot="status" slot-scope="status">
            <a-tag v-if="status === 'Enable'" color="green">{{ status }}</a-tag>
            <a-tag v-if="status === 'Disable'" color="red">{{ status }}</a-tag>
          </template>
        </a-table>
      </a-card>

      <!--
        Remark
      -->
      <a-card :bordered="false" class="header-solid h-full mb-24">
        <template #title>
          <a-row type="flex" justify="space-between" align="top">
            <a-col :span="24">
              <h5 class="font-semibold m-0">Remark</h5>
            </a-col>
          </a-row>
        </template>
        <div style="margin-left: 10px">
          {{ room.remark }}
        </div>
      </a-card>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import tools from "../../utils/tools";

export default {
  props: {},
  components: {},
  data() {
    return {
      data: [],
      columns: [
        {
          title: "Name",
          dataIndex: "name",
          scopedSlots: { customRender: "name" }
        },
        {
          title: "Type",
          dataIndex: "type",
          scopedSlots: { customRender: "type" }
        },
        {
          title: "Floor",
          dataIndex: "floor",
          scopedSlots: { customRender: "floor" }
        },
        {
          title: "IP",
          dataIndex: "ip",
          scopedSlots: { customRender: "ip" }
        },
        {
          title: "Card",
          dataIndex: "rfid",
          scopedSlots: { customRender: "rfid" }
        },
        {
          title: "Capacity",
          dataIndex: "capacity",
          scopedSlots: { customRender: "capacity" }
        },
        {
          title: "Always On",
          dataIndex: "open",
          scopedSlots: { customRender: "open" }
        },
        {
          title: "Allow Booking",
          dataIndex: "allowBooking",
          scopedSlots: { customRender: "allowBooking" }
        },
        {
          title: "Status",
          dataIndex: "status",
          scopedSlots: { customRender: "status" }
        }
      ],
      room: {
        _id: "",
        name: "",
        floor: "",
        type: "",
        ip: "",
        open: "",
        rfid: "",
        capacity: 1,
        allowBooking: "",
        status: "",
        remark: ""
      },
      isVisible: false
    };
  },
  //
  //
  //
  mounted() { },
  methods: {
    //
    //
    //
    isMobile() {
      return tools.isMobile();
    },
    //
    //
    //
    setInfo(room) {
      this.room = room;
      this.data.push(room);
    },
    //
    // Edit data.
    //
    async onEdit() {
      this.isVisible = true;
      this.id = this.room._id;
      this.name = this.room.name;
      this.floor = this.room.floor;
      this.type = this.room.type;
      this.rfid = this.room.rfid;
      this.ip = this.room.ip;
      this.capacity = this.room.capacity;
      this.allowBooking = this.room.allowBooking;
      this.status = this.room.status;
      this.remark = this.room.remark;
    },
    //
    //
    //
    onSubmit() {
      this.isVisible = false;
      axios
        .put(
          process.env.VUE_APP_INVENTORY_API + "/rooms/" + this.room._id,
          {
            name: this.room.name,
            floor: this.room.floor,
            type: this.room.type,
            ip: this.room.ip,
            rfid: this.room.rfid,
            capacity: this.room.capacity,
            allowBooking: this.room.allowBooking,
            status: this.room.status,
            remark: this.room.remark
          },
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("accessToken")
            }
          }
        )
        .then(response => {
          this.$notification.open({
            message: "Notification",
            description: "Completed",
            icon: <a-icon type="check-circle" style="color: #00FF00" />
          });
        })
        .catch(error => {
          console.log(error);
          return;
        });
    },
    //
    // Delete data.
    //
    onDelete() {
      const self = this;
      this.$confirm({
        title: "ต้องการลบข้อมูลนี้หรือไม่?",
        onOk() {
          self.delete();
        },
        onCancel() { }
      });
    },
    //
    //
    //
    delete() {
      axios
        .delete(process.env.VUE_APP_INVENTORY_API + "/rooms/" + this.room._id, {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken")
          }
        })
        .then(response => {
          this.$notification.open({
            message: "Notification",
            description: "Completed",
            icon: <a-icon type="check-circle" style="color: #00FF00" />
          });
          this.$router.push("/rooms");
        })
        .catch(error => {
          console.log(error);
          return;
        });
    },
    //
    //
    //
    onToggleOnOff(checked) {
      let endpoint = "";
      if (this.room.open === false) {
        endpoint =
          process.env.VUE_APP_INVENTORY_API + "/rooms/open/" + this.room._id;
      } else {
        endpoint =
          process.env.VUE_APP_INVENTORY_API + "/rooms/close/" + this.room._id;
      }
      axios
        .put(
          endpoint,
          {},
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("accessToken")
            }
          }
        )
        .then(response => {
          this.$notification.open({
            message: "Notification",
            description: "Completed",
            icon: <a-icon type="check-circle" style="color: #00FF00" />
          });
          this.requestData();
        })
        .catch(error => {
          console.log(error);
          return;
        });
    }
  }
};
</script>

<style lang="scss"></style>
